/*
 *
 *  THIS FILE IS DEPRECATED AND WILL BE REMOVED IN A FUTURE VERSION
 *  DO NOT EDIT THIS FILE
 *
 */

import { css } from 'styled-components';

const fontFaces = css``;

export default fontFaces;
